import { render, staticRenderFns } from "./WabizListTile.vue?vue&type=template&id=61375aee&"
import script from "./WabizListTile.vue?vue&type=script&lang=js&"
export * from "./WabizListTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports